var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCastle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4462 6.96766C5.3283 6.96766 6.85405 5.44192 6.85405 3.55982C6.85405 1.67772 5.3283 0.151978 3.4462 0.151978C1.5641 0.151978 0.0383606 1.67772 0.0383606 3.55982C0.0383606 5.44192 1.5641 6.96766 3.4462 6.96766Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85405 18.8952H0.0383606V15.4874L3.4462 10.3756L6.85405 15.4874V18.8952Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7095 18.8952H23.8938V15.4874L27.3017 10.3756L30.7095 15.4874V18.8952Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.261 10.3756V22.3031H20.4845V10.3756H10.261ZM17.0767 18.8952H13.6689V15.4874C13.6689 15.0355 13.8484 14.6021 14.1679 14.2825C14.4875 13.963 14.9209 13.7835 15.3728 13.7835C15.8247 13.7835 16.2581 13.963 16.5776 14.2825C16.8972 14.6021 17.0767 15.0355 17.0767 15.4874V18.8952Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.74344 17.192V32.5273H11.967V27.4155C11.967 26.5117 12.326 25.6449 12.9651 25.0058C13.6042 24.3667 14.471 24.0077 15.3748 24.0077C16.2786 24.0077 17.1454 24.3667 17.7845 25.0058C18.4236 25.6449 18.7827 26.5117 18.7827 27.4155V32.5273H29.0062V17.192L25.5982 18.8959H5.15172L1.74344 17.192ZM8.55913 27.4155H5.15128V24.0077C5.15128 23.5558 5.3308 23.1224 5.65035 22.8028C5.9699 22.4833 6.4033 22.3038 6.8552 22.3038C7.30711 22.3038 7.74051 22.4833 8.06006 22.8028C8.37961 23.1224 8.55913 23.5558 8.55913 24.0077V27.4155ZM25.5983 27.4155H22.1905V24.0077C22.1905 23.5558 22.37 23.1224 22.6896 22.8028C23.0091 22.4833 23.4425 22.3038 23.8944 22.3038C24.3463 22.3038 24.7797 22.4833 25.0993 22.8028C25.4188 23.1224 25.5983 23.5558 25.5983 24.0077V27.4155Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1893 12.0794H8.55789V8.67159L15.3736 0.151978L22.1893 8.67159V12.0794Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0048 6.96745L25.597 3.5596H28.1528L29.0048 2.70764L29.8568 3.5596H32.4126L29.0048 6.96745Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastle);
export default __webpack_public_path__ + "static/media/castle.46addc134c932fc2a2dee3ce7f18c247.svg";
export { ForwardRef as ReactComponent };